<template>
  <div class="o-search">
    <VForm :onSubmit="onSearch">
      <div slot="row">
        <div class="o-search__input">
          <VInput
            type="text"
            :placeholder="placeholder"
            :icon="true"
            :fluid="true"
            size="small"
            v-model="search"
            :clearButton="true"
            :buttonDisabled="search.length === 0">
            <SearchIcon />
          </VInput>
        </div>
      </div>
    </VForm>
  </div>
</template>

<script>
import VInput from '@/components/deprecated/atoms/Input.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import { SearchIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VSearch',
  introduction: 'A search input. To be moved into the app.',
  components: {
    VInput,
    VForm,
    SearchIcon,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search',
      note: 'The placeholder of the input.',
    },
  },
  data() {
    return {
      search: '',
    };
  },
  created() {
    if (this.$route.query.q) {
      this.search = this.$route.query.q;
      this.onSearch();
    }
  },
  methods: {
    updateSearch() {
      this.$emit('input', this.search);
    },
    onSearch() {
      if (this.$route.query.q !== this.search) this.$router.replace({ query: { q: this.search } });
      this.$emit('onSearch', { value: this.search });
    },
  },
  watch: {
    search: {
      handler(value) {
        this.updateSearch();
        if (value.length === 0) {
          if (this.$route.query.q) this.$router.replace({ query: {} });
          this.$emit('onResetSearch');
        }
      },
    },
  },
};
</script>

<style scoped>
.o-filter {
  background: #fff;
  padding: var(--spacing-base);
  margin-bottom: var(--spacing-base);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  position: relative;
}

.o-filter:after {
  content: '';
  display: block;
  clear: both;
}

.o-filter__input {
  /* margin-bottom: $spacing-small; */
}

.o-filter__input:after {
  content: '';
  display: block;
  clear: both;
}

.o-filter__labels {
  margin-top: var(--spacing-small);
}

.o-filter__labels:after {
  content: '';
  display: block;
  clear: both;
}

.o-filter__button {
  position: absolute;
  right: var(--spacing-base);
  bottom: var(--spacing-base);
}
</style>
